import createIcon from '../../createIcon';

/**
 * @component @name DeveloperMode
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNyA1SDE3VjdIMTlWM0MxOSAxLjkgMTguMSAxLjAxIDE3IDEuMDFMNyAxQzUuOSAxIDUgMS45IDUgM1Y3SDdWNVpNMTUuNDEgMTYuNTlMMjAgMTJMMTUuNDEgNy40MUwxNCA4LjgzTDE3LjE3IDEyTDE0IDE1LjE3TDE1LjQxIDE2LjU5Wk0xMCAxNS4xN0w2LjgzIDEyTDEwIDguODNMOC41OSA3LjQxTDQgMTJMOC41OSAxNi41OUwxMCAxNS4xN1pNMTcgMTlIN1YxN0g1VjIxQzUgMjIuMSA1LjkgMjMgNyAyM0gxN0MxOC4xIDIzIDE5IDIyLjEgMTkgMjFWMTdIMTdWMTlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DeveloperMode = createIcon('DeveloperMode', [
  [
    'path',
    {
      d: 'M7 5H17V7H19V3C19 1.9 18.1 1.01 17 1.01L7 1C5.9 1 5 1.9 5 3V7H7V5ZM15.41 16.59L20 12L15.41 7.41L14 8.83L17.17 12L14 15.17L15.41 16.59ZM10 15.17L6.83 12L10 8.83L8.59 7.41L4 12L8.59 16.59L10 15.17ZM17 19H7V17H5V21C5 22.1 5.9 23 7 23H17C18.1 23 19 22.1 19 21V17H17V19Z',
      key: '1a5z3b',
    },
  ],
]);

export default DeveloperMode;
